"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUI_FEE_TABLE_IDS = exports.SUI_CONFIG_IDS = exports.SUI_PROGRAM_IDS = void 0;
var types_1 = require("../common/types");
exports.SUI_PROGRAM_IDS = (_a = {},
    _a[types_1.ICluster.Mainnet] = "0x97e9a9fb1392e9785319f5512d0bfde6ecf7757b09c6de41cec89e798dd361f2",
    _a[types_1.ICluster.Devnet] = "0x97e9a9fb1392e9785319f5512d0bfde6ecf7757b09c6de41cec89e798dd361f2",
    _a[types_1.ICluster.Testnet] = "0x97e9a9fb1392e9785319f5512d0bfde6ecf7757b09c6de41cec89e798dd361f2",
    _a[types_1.ICluster.Local] = "0x97e9a9fb1392e9785319f5512d0bfde6ecf7757b09c6de41cec89e798dd361f2",
    _a);
exports.SUI_CONFIG_IDS = (_b = {},
    _b[types_1.ICluster.Mainnet] = "0xb235494fd29ad70647bfb15c18d0b9ca2aa568ab94ec27fd53a43715775dd5d8",
    _b[types_1.ICluster.Devnet] = "0xb235494fd29ad70647bfb15c18d0b9ca2aa568ab94ec27fd53a43715775dd5d8",
    _b[types_1.ICluster.Testnet] = "0xb235494fd29ad70647bfb15c18d0b9ca2aa568ab94ec27fd53a43715775dd5d8",
    _b[types_1.ICluster.Local] = "0xb235494fd29ad70647bfb15c18d0b9ca2aa568ab94ec27fd53a43715775dd5d8",
    _b);
exports.SUI_FEE_TABLE_IDS = (_c = {},
    _c[types_1.ICluster.Mainnet] = "0x321175a859a97c2ade153d302d3c777247f24a3836c84d2d1fb78369c1403d81",
    _c[types_1.ICluster.Devnet] = "0x321175a859a97c2ade153d302d3c777247f24a3836c84d2d1fb78369c1403d81",
    _c[types_1.ICluster.Testnet] = "0x321175a859a97c2ade153d302d3c777247f24a3836c84d2d1fb78369c1403d81",
    _c[types_1.ICluster.Local] = "0x321175a859a97c2ade153d302d3c777247f24a3836c84d2d1fb78369c1403d81",
    _c);
